import { Anschrift } from "./anschrift"

/**
 * BG-11: TaxRepresentativeParty
 * Kardinalität: 0..1
 */
export class Steuervertreter {
    // BT-62
    name?: string
    // BT-63
    umsatzsteuerId?: string

    anschrift: Anschrift = new Anschrift()

    get notEmpty(): boolean {
        return ((this.name && this.name.trim().length > 0) ||
            (this.umsatzsteuerId && this.umsatzsteuerId.trim().length > 0) ||
            this.anschrift.notEmpty) as boolean
    }

    toJSON() {
        return {
            name: this.name,
            umsatzsteuerId: this.umsatzsteuerId,
            anschrift: this.anschrift.toJSON(),
        }
    }
}
